import { render, staticRenderFns } from "./JoinAtl.vue?vue&type=template&id=5ba39746&scoped=true&"
import script from "./JoinAtl.vue?vue&type=script&lang=js&"
export * from "./JoinAtl.vue?vue&type=script&lang=js&"
import style0 from "./JoinAtl.vue?vue&type=style&index=0&id=5ba39746&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba39746",
  null
  
)

export default component.exports